var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.868 85.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_invoice",
    "data-name": "icon invoice",
    transform: "translate(2771 7423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-2771 -7417.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M-2722.421-7312.013h-44.111a4.474,4.474,0,0,1-4.469-4.469v-71.05a4.474,4.474,0,0,1,4.469-4.469h31.823l-1.795,2.287a11.939,11.939,0,0,0-2.569,7.442,12.07,12.07,0,0,0,12.056,12.056,11.975,11.975,0,0,0,6.845-2.131l2.218-1.533v57.4A4.474,4.474,0,0,1-2722.421-7312.013Zm-44.111-77.16a1.643,1.643,0,0,0-1.641,1.642v71.05a1.643,1.643,0,0,0,1.641,1.642h44.111a1.643,1.643,0,0,0,1.641-1.642v-52.271a14.815,14.815,0,0,1-6.236,1.364,14.9,14.9,0,0,1-14.883-14.883,14.753,14.753,0,0,1,1.689-6.9Z",
    transform: "translate(2771 7392)",
    fill: "#252b43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-2761.084 -7365.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M-2679.884-7073.519h-30.072a1.413,1.413,0,0,1-1.414-1.413,1.414,1.414,0,0,1,1.414-1.414h30.072a1.413,1.413,0,0,1,1.414,1.414A1.413,1.413,0,0,1-2679.884-7073.519Z",
    transform: "translate(2711.369 7076.345)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-2761.084 -7377.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M-2679.884-7147.518h-30.072a1.414,1.414,0,0,1-1.414-1.414,1.413,1.413,0,0,1,1.414-1.413h30.072a1.413,1.413,0,0,1,1.414,1.413A1.413,1.413,0,0,1-2679.884-7147.518Z",
    transform: "translate(2711.369 7150.345)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-2761.084 -7353.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M-2679.884-6999.518h-30.072a1.414,1.414,0,0,1-1.414-1.414,1.414,1.414,0,0,1,1.414-1.414h30.072a1.413,1.413,0,0,1,1.414,1.414A1.414,1.414,0,0,1-2679.884-6999.518Z",
    transform: "translate(2711.369 7002.345)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-2760.496 -7407.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M-2704.009-7322.15v-2.524a7.278,7.278,0,0,1-3.823-1.1l.6-1.674a6.661,6.661,0,0,0,3.6,1.074c1.774,0,2.974-1.024,2.974-2.449,0-1.375-.975-2.224-2.824-2.974-2.549-1-4.123-2.149-4.123-4.323a4.1,4.1,0,0,1,3.773-4.023v-2.524h1.55v2.424a6.666,6.666,0,0,1,3.249.875l-.625,1.649a6.041,6.041,0,0,0-3.148-.85c-1.924,0-2.649,1.15-2.649,2.149,0,1.3.925,1.949,3.1,2.849,2.574,1.049,3.873,2.349,3.873,4.573a4.346,4.346,0,0,1-3.948,4.248v2.6Z",
    transform: "translate(2707.832 7342.666)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-2741.899 -7423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M-2581.117-7393.233A14.9,14.9,0,0,1-2596-7408.117a14.742,14.742,0,0,1,3.172-9.187,14.811,14.811,0,0,1,11.711-5.7,14.9,14.9,0,0,1,14.883,14.883,14.893,14.893,0,0,1-6.43,12.251A14.8,14.8,0,0,1-2581.117-7393.233Zm0-26.939a12,12,0,0,0-9.488,4.615,11.94,11.94,0,0,0-2.568,7.441,12.07,12.07,0,0,0,12.056,12.056,11.978,11.978,0,0,0,6.845-2.13,12.065,12.065,0,0,0,5.211-9.926A12.07,12.07,0,0,0-2581.117-7420.173Z",
    transform: "translate(2596 7423)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-2733.584 -7415.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    d: "M-2539.433-7364.536a1.415,1.415,0,0,1-1.226-.71l-5.155-8.98a1.414,1.414,0,0,1,.522-1.93,1.415,1.415,0,0,1,1.929.522l3.714,6.47,4.062-9.958a1.413,1.413,0,0,1,1.843-.775,1.414,1.414,0,0,1,.775,1.843l-5.155,12.639a1.412,1.412,0,0,1-1.214.876C-2539.37-7364.538-2539.4-7364.536-2539.433-7364.536Z",
    transform: "translate(2546.002 7380.002)",
    fill: "#252b43"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.7060dbb0.svg";
export { ForwardRef as ReactComponent };